import type { PropsWithChildren } from "react";

import { Disclosure, DisclosureHeader, DisclosurePanel } from "@stacklet/ui";

import { Link } from "app/components/links";
import { paths } from "app/constants/paths";

/**
 * The personal-API-key route, folded away by default.
 *
 * OAuth is the way we want people to connect, and a key costs them Redash
 * access, so the alternative is offered rather than presented: collapsed, and
 * with the trade-off stated before the commands rather than after.
 */
export function PersonalApiKeyDisclosure({ children }: PropsWithChildren) {
  return (
    <Disclosure>
      <DisclosureHeader
        className="w-fit gap-x-xs text-title-small"
        position="leading"
      >
        Using a Personal API Key (Optional)
      </DisclosureHeader>

      <DisclosurePanel>
        <div className="flex flex-col gap-md pt-xs">
          <p className="text-body-medium text-text-secondary">
            OAuth is the preferred way to authenticate. You can instead use a
            personal API key, but a key-authenticated MCP session has no access
            to Redash. Create an API key in{" "}
            <Link to={paths.settingsProfile}>Profile Settings</Link>, then run:
          </p>

          {children}
        </div>
      </DisclosurePanel>
    </Disclosure>
  );
}
